import { Component, OnInit, ViewEncapsulation,OnDestroy, ElementRef,Renderer2} from '@angular/core';
import { ApiService } from '../api.service';
import { ObservablesService } from '../observables.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdminDashboardComponent implements OnInit {
  users:any=[]
  treeData:any=[]
  selectedLevelData:any=[]
  loggedUserInfo:any=[];
  selectedClient:any={};
  selectedData:any;
  selectedTagData:any;
  selectedLastClient:any;
  viewDashboardStatus:boolean = false;
  setHeaderDataObserver:any;
  showMobileDashboardObserver:any;
  selectedIndex: number = 0;


  constructor(private api:ApiService,private router:Router, private observables:ObservablesService,private ele:ElementRef,private renderer:Renderer2) {

    this.showMobileDashboardObserver = this.observables.showMobileDashboardStatus.subscribe(()=>{
      // console.log("goto dashborad")
      this.viewDashboardStatus = false;
    })

    this.setHeaderDataObserver = this.observables.setHeaderData.subscribe((response:any)=>{
      setTimeout(()=>{

        this.selectedData = response;
      })
    })


    this.observables.getHeaderStatus.next()


  }

  ngOnDestroy(){
    this.setHeaderDataObserver.unsubscribe()
    this.showMobileDashboardObserver.unsubscribe()
  }


  ngOnInit() {

    this.api.getLoggedUserInfo().then((res:any)=>{
      if(res.data.length > 0){
        this.loggedUserInfo = res.data[0];

        // console.log("this.loggedUserInfo=",this.loggedUserInfo)

      }else{
        this.api.logOut()
      }
    })
  }

  gotoMobileDashboard(){
    this.viewDashboardStatus = true;
  }


  userSelected(data:any){
    // console.log("data=",data)
    this.selectedLevelData = data;
  }
  clientSelected(data:any){
    this.selectedLastClient = data;
  }

  setClient(data){
    // console.log("client selected=",data)
    this.observables.resetPartySearchStatus.next()
    this.selectedClient = data;
  }

  onTabChange(event){

  }

}
